(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219],{

/***/ 7755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
}), 'Autorenew'));

/***/ }),

/***/ 8305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(92721);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7755);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66684);



var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        spinner: {
            animation: "$spin infinite 2s linear"
        },
        "@keyframes spin": {
            from: {
                transform: "rotate(0deg)"
            },
            to: {
                transform: "rotate(360deg)"
            }
        }
    };
});
var Spinner = function() {
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        "data-testid": "spinner",
        className: classes.spinner
    }));
};


/***/ }),

/***/ 92721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/dashboard/DashboardLayout.tsx + 24 modules
var DashboardLayout = __webpack_require__(88508);
// EXTERNAL MODULE: ./src/components/loaders/Spinner.tsx
var Spinner = __webpack_require__(894);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/hooks/useAvailableTests.ts

var useAvailableTests = function(client_id, is_complete) {
    var url = typeof client_id === "number" ? "test/response?client_id=".concat(client_id, "&is_complete=").concat(is_complete ? "true" : "false") : null;
    var ref = (0,dist/* default */.ZP)(url), data = ref.data, error = ref.error;
    return {
        tests: data,
        loading: !data && !error
    };
};

// EXTERNAL MODULE: ./src/hooks/useSlugRouter.ts
var useSlugRouter = __webpack_require__(14794);
;// CONCATENATED MODULE: ./src/pages/[slug]/index.tsx









var hasMenu = function(menu, permissions) {
    return permissions.menus.some(function(m) {
        return m.menu_id === menu;
    });
};
var Home = function() {
    var router = (0,useSlugRouter/* useSlugRouter */.r)();
    var permissions = (0,useAuth/* useAuth */.a)().permissions;
    var ref = (0,useAuth/* useAuth */.a)(), client = ref.client, isBaseStudent = ref.isBaseStudent, isAuthenticated = ref.isAuthenticated, isInitialized = ref.isInitialized;
    var tests = useAvailableTests(client === null || client === void 0 ? void 0 : client.client_id, false).tests;
    react.useEffect(function() {
        var dashboard = "";
        if (hasMenu("admin_dashboard", permissions)) {
            dashboard = routes/* ROUTES.DASHBOARD_ADMIN */.Z.DASHBOARD_ADMIN;
        } else if (hasMenu("user_dashboard", permissions)) {
            dashboard = routes/* ROUTES.DASHBOARD_USER */.Z.DASHBOARD_USER;
        } else if (isBaseStudent) {
            if (client && tests) {
                if (tests.length === 0) {
                    dashboard = routes/* ROUTES.TESTS_NO_TEST */.Z.TESTS_NO_TEST;
                } else {
                    dashboard = "".concat(routes/* ROUTES.TEST */.Z.TEST, "?test_id=").concat(tests[0].fawbstest_id, "&response_id=").concat(tests[0].youth_results_id);
                }
            }
        }
        if (dashboard) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            router.push(dashboard);
        } else if (!isAuthenticated && isInitialized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
        }
    }, [
        client,
        isBaseStudent,
        permissions,
        router,
        tests,
        isAuthenticated,
        isInitialized, 
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
        title: "Redirecting",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            ml: 1,
                            pt: 1
                        },
                        children: "Redirecting"
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var _slug_ = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9436,4230,7462,6402,235,8508,9774,2888,179], function() { return __webpack_exec__(8305); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);